import { mapState, mapGetters } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import filter from 'lodash/filter';
import { vuetifyColors } from '@/utils/themes';
import { userItemsPerListMixin } from '@/utils/vuex';
const defaultItemsPerPage = 10;
const defaultTableOptions = {
  sortBy: ['id'],
  sortDesc: [false],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'NiotaClassicDevicesMultipleEditList',
  mixins: [userItemsPerListMixin],
  props: {
    devices: {
      type: Array,
      required: false,
      default: undefined
    }
  },
  data: function () {
    return {
      tableHeaders: [{
        text: this.$i18n_t('NiotaClassic.Common.table.id'),
        value: 'id',
        align: 'right'
      }, {
        text: this.$i18n_t('NiotaClassic.Devices.table.name'),
        value: 'title'
      }, {
        text: this.$i18n_t('NiotaClassic.Common.table.eui'),
        value: 'eui'
      }, {
        sortable: false
      }, {
        sortable: false
      }],
      tableOptions: {
        ...defaultTableOptions
      },
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [defaultItemsPerPage, 20, 50]
      },
      list: [],
      searchItem: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapGetters({
      sessionUserId: 'authentication/userId'
    })
  },
  watch: {
    devices() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.list = cloneDeep(this.devices);
    },
    deleteFromList(item) {
      this.list = filter(this.list, device => device.id !== item.id);
      this.$emit('updateList', this.list);
    },
    getColor(type) {
      return vuetifyColors[type];
    }
  }
};